import { getFacilitiesTemplate } from "@/api/template";
import FileDownloader, { FileDownloaderProps } from "@/components/FileDownloader/FileDownloader";

export default function DownloadUtilitiesTemplate(props: Partial<FileDownloaderProps>) {
  return (
    <FileDownloader
      fileOutputName={`template-facilities.xlsx`}
      fileUrlFn={getFacilitiesTemplate}
      {...props}
    />
  );
}
